import styled from 'styled-components';
import { softControlMotion } from '@/theme/interactions';
import { Form } from './styles';

export const SearchLayout = styled.div`
  container-type: inline-size;
  margin-bottom: 18px;
`;
export const SearchRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: stretch;
  gap: 10px;
`;
export const FilterToggle = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 14px;
  min-height: 44px;
  border: 1px solid ${({ theme }) => theme.color.hairSoft};
  border-radius: ${({ theme }) => theme.radius.md};
  background: ${({ theme }) => theme.color.surface};
  color: ${({ theme }) => theme.color.textPrimary};
  font: 600 ${({ theme }) => theme.fontSize.sm} ${({ theme }) => theme.font.body};
  cursor: pointer;
  ${softControlMotion}
  &[aria-expanded='true'], &:hover {
    background-color: ${({ theme }) => theme.color.hover};
  }
  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.color.focusRing};
    outline-offset: 3px;
  }
  span {
    min-width: 18px;
    padding: 1px 4px;
    border-radius: 20px;
    background: ${({ theme }) => theme.color.accentCyan};
    color: ${({ theme }) => theme.color.onAccent};
    font-size: 11px;
  }
  @container (max-width: 420px) {
    padding: 10px;
    gap: 5px;
    > svg:first-child {
      display: none;
    }
  }
`;
export const FilterPanel = styled.section`
  margin-top: 12px;
  padding: 20px;
  border: 1px solid ${({ theme }) => theme.color.glassBorder};
  border-radius: ${({ theme }) => theme.radius.lg};
  background: ${({ theme }) => theme.color.surface};
  display: flex;
  flex-direction: column;
  gap: 18px;
  &[hidden] {
    display: none;
  }
  @container (max-width: 440px) {
    padding: 14px;
  }
`;
export const PanelHead = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  h2 {
    margin: 0 0 5px;
    font-size: ${({ theme }) => theme.fontSize.lg};
  }
  p {
    margin: 0;
  }
  > button {
    flex-shrink: 0;
    padding: 8px;
  }
`;
export const FilterForm = styled(Form)`
  padding-top: 18px;
  border-top: 1px solid ${({ theme }) => theme.color.hairSoft};
  gap: 18px;
  label {
    font-size: ${({ theme }) => theme.fontSize.sm};
    gap: 8px;
  }
  input,
  select {
    min-height: 44px;
    width: 100%;
    font-size: ${({ theme }) => theme.fontSize.sm};
    color-scheme: ${({ theme }) => theme.mode};
  }
`;
export const FieldGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px 16px;
  @container (max-width: 680px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @container (max-width: 440px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;
export const InputWrap = styled.span`
  display: flex;
  align-items: center;
  position: relative;
  min-width: 0;
  > svg {
    position: absolute;
    left: 12px;
    pointer-events: none;
    color: ${({ theme }) => theme.color.textMuted};
  }
  > svg + input {
    padding-left: 38px;
  }
`;
export const FilterFooter = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  > p {
    margin: 0;
    max-width: 46ch;
  }
`;
export const FilterActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;
